import { Container as MuiContainer, Breakpoint } from "@mui/material";
import { PropsWithChildren } from "react";

interface Props extends PropsWithChildren {
  children: React.ReactNode;
  maxWidth?: Breakpoint | false;
  noOffset?: boolean;
}

export const PageWrapper: React.FC<Props> = ({ noOffset, ...props }) => {
  return (
    <MuiContainer
      sx={{
        paddingTop: noOffset ? "0" : "48px",
        "@media (min-width: 900px)": {
          paddingLeft: "48px",
          paddingRight: "48px",
        },
      }}
      {...props}
    ></MuiContainer>
  );
};
